import { Cloud, RefreshCw, Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useAppSelector } from '@/store/hooks'

/** Cloud save-status indicator (ref parity): colour + overlay reflect the save state. */
export const SaveStatusIndicator = () => {
  const status = useAppSelector((s) => s.editor.saveStatus)

  const cloudColor = cn(
    'h-5 w-5 transition-colors',
    status === 'saving' && 'text-muted-foreground',
    status === 'error' && 'text-warning',
    status === 'saved' && 'text-success',
    status === 'idle' && 'text-muted-foreground',
  )

  return (
    <div className="relative flex h-8 w-8 items-center justify-center">
      <Cloud className={cloudColor} />
      {status === 'saving' ? (
        <RefreshCw className="absolute bottom-0.5 right-0.5 h-3 w-3 animate-spin text-primary" />
      ) : status === 'saved' ? (
        <Check className="absolute bottom-0.5 right-0.5 h-3 w-3 text-success" />
      ) : null}
    </div>
  )
}
